import { render } from "./magicAuth.vue?vue&type=template&id=7513becc&lang=html"
import script from "./magicAuth.vue?vue&type=script&lang=js"
export * from "./magicAuth.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__